import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { BudgeRightArrow } from "./icon";

import { PATH_HOME, enumTheme } from "@configs";
import { PageUserDetail } from "@pages";
import { resetDetailUser, selectAuth, selectMerchant, setDetailUser } from "@redux";
import { useHistory } from "react-router";
import { LangDropdown } from "./LangDropdown";
import { HomeIcon } from "./icon";
import { Banner } from "./shared";

interface IProp {
    children?: JSX.Element;
    handleInitalQrCode?: () => void;
}

export const ComponentHeaderAuth = (props: IProp) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || enumTheme.LIGHT;
    const history = useHistory();
    const location = useLocation();
    //page variable
    const merchant = useSelector(selectMerchant);
    const { detailUser } = useSelector(selectAuth);
    const { children, handleInitalQrCode } = props;
    const { userInfo } = useSelector(selectAuth);
    const isHomePath = location.pathname === "/" || location.pathname === "/home";
    const containerZIndex = isHomePath ? 1 : 0;

    const handleDetail = () => {
        dispatch(setDetailUser());
    };

    const handleBackHome = () => {
        dispatch(resetDetailUser());
        handleInitalQrCode && handleInitalQrCode();
    };
    const modeColor = themeMode === enumTheme.DARK ? "#000000" : merchant.themes?.themeColor;

    const renderCorporateUi = () => {
        // if (merchant.superAdminAdvanceFeature?.isCorporateUi) {
        //     return null;
        // } else {
        return (
            <StyledContainerHeaderAuth
                bg_color={modeColor!}
                sub_color={merchant.themes?.subColor || ""}
                id="bannersme"
                zIndex={containerZIndex}
            >
                {merchant?.themes?.logoUrl ? (
                    <div className="image">
                        <img src={merchant.themes?.logoUrl} />
                    </div>
                ) : (
                    <Banner color={themes?.themeColor!} />
                )}
                <div className="content">
                    <StyledContentLayout>
                        {detailUser ? (
                            <HomeIcon
                                onClick={handleBackHome}
                                color={merchant.themes?.themeColor!}
                            />
                        ) : (
                            <>
                                {merchant?.themes?.logoSmallUrl ? (
                                    <>
                                        {merchant?.advanceSettings?.advanceFeature
                                            ?.isCorporateUi === true ? null : (
                                            <div
                                                className="logo-image"
                                                onClick={() => history.push(PATH_HOME)}
                                            >
                                                {<img src={merchant?.themes?.logoSmallUrl} />}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <StyleHomeButton
                                        color={themes?.themeColor!}
                                        onClick={handleBackHome}
                                    >
                                        {merchant.name}
                                    </StyleHomeButton>
                                )}
                                {!merchant.advanceSettings?.advanceFeature?.isCorporateUi && (
                                    <StyledButton onClick={handleDetail}>
                                        {t("page.membership_details")}
                                        <BudgeRightArrow
                                            stoke={`${themeMode === "dark" ? "black" : "white"}`}
                                        />
                                    </StyledButton>
                                )}
                            </>
                        )}
                    </StyledContentLayout>
                    <LangDropdown />
                </div>
                <div className="background--sub"></div>
            </StyledContainerHeaderAuth>
        );
        // };
    };
    return (
        <>
            {renderCorporateUi()}
            {!detailUser ? children : <PageUserDetail />}
        </>
    );
};

const StyledContainerHeaderAuth = styled.div<{
    bg_color: string;
    sub_color: string;
    zIndex: number | string;
}>`
    width: 100%;
    height: 225px;
    background-color: ${(p) => p.bg_color};
    position: relative;
    z-index: ${(p) => p.zIndex};
    // overflow: hidden;
    .image {
        height: 100%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .content {
        position: absolute;
        top: 16px;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        width: 100%;
        align-items: center;
        img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
        }
        .name {
            font-style: normal;
            font-size: 18px;
            line-height: 24px;
            color: #ffffff;
            margin: 0 0 12px 0px;
            max-width: 220px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 500;
        }
    }
    .background--sub {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 59px;
        width: 100%;
        background: linear-gradient(to top, ${(p) => p.theme.colors.home_bg}, transparent);
    }
`;

const StyledButton = styled.div`
    padding: 4px 8px;
    background: rgba(0, 0, 0, 0.22);
    border-radius: 20px;
    color: #fff;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;
    width: fit-content;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    &:hover {
        background: rgba(0, 0, 0, 0.8);
        transition: 0.6s;
    }
`;

const StyleHomeButton = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    color: #fff;
    border: 2px solid #fff;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    margin: 0;
    width: 36px;
    height: 36px;
    padding: 3px;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.8);
    width: 36px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
const StyledContentLayout = styled.div`
    display: flex;
`;
